export const GET_TEACHERS = "GET_TEACHERS"
export const GET_TEACHERS_FAIL = "GET_TEACHERS_FAIL"
export const GET_TEACHERS_SUCCESS = "GET_TEACHERS_SUCCESS"

export const ADD_NEW_TEACHER = "ADD_NEW_TEACHER"
export const ADD_TEACHER_SUCCESS = "ADD_TEACHER_SUCCESS"
export const ADD_TEACHER_FAIL = "ADD_TEACHER_FAIL"

export const UPDATE_TEACHER = "UPDATE_TEACHER"
export const UPDATE_TEACHER_SUCCESS = "UPDATE_TEACHER_SUCCESS"
export const UPDATE_TEACHER_FAIL = "UPDATE_TEACHER_FAIL"

export const DELETE_TEACHER = "DELETE_TEACHER"
export const DELETE_TEACHER_SUCCESS = "DELETE_TEACHER_SUCCESS"
export const DELETE_TEACHER_FAIL = "DELETE_TEACHER_FAIL"





